<template>
  <dashboard-collapsible-card
    title="Recherches"
    :collapsed="collapsed"
    collapsed-icon="fas fa-search text-primary-600"
    card-class="dashboard-overview-card dashboard-overview-card--searches h-full flex flex-col"
    header-class="dashboard-card-header"
    content-class="dashboard-keywords-card__content"
    @toggle="$emit('toggle')"
  >
    <!-- <template #title-append>
      <span
        v-if="periodLabel"
        class="inline-flex items-center gap-1 rounded-full border border-primary-200 bg-white/80 px-2.5 py-0.5 text-xs font-medium text-primary-600"
      >
        <i class="fas fa-calendar-alt"></i>
        <span>{{ periodLabel }}</span>
      </span>
    </template> -->
    <template #header-actions>
      <dashboard-metric-chip
        label="Total"
        :value="formatNumber(totalSearches)"
        tooltip="Sur la période"
      />
    </template>
    <template #header-actions-after>
      <dashboard-tooltip-pill
        tooltip="Exporter les mots-clés les plus recherchés (format CSV)"
        variant="text"
      >
        <button
          type="button"
          class="dashboard-icon-button"
          :disabled="isExporting"
          @click="$emit('export')"
        >
          <i class="fas fa-download" v-if="!isExporting"></i>
          <i class="fas fa-spinner fa-spin" v-else></i>
          <span class="sr-only">Exporter</span>
        </button>
      </dashboard-tooltip-pill>
    </template>

    <template #collapsed-description>
      <p class="text-xs text-gray-500">Top 10</p>
    </template>

    <div class="dashboard-keywords-card">
      <section class="dashboard-top-list dashboard-top-list--alerts">
        <h4>Mots sensibles</h4>
        <dashboard-list-state
          :loading="loadingPopularities"
          :has-data="keywordAlerts.length"
          class="dashboard-alerts-list-state"
        >
          <template #default>
            <div class="dashboard-alerts-scroll">
              <ol class="dashboard-compact-list dashboard-compact-list--alerts">
                <li
                  v-for="alert in keywordAlerts"
                  :key="alert.word"
                >
                  <span><i class="fas fa-exclamation-triangle"></i></span>
                  <dashboard-tooltip-pill
                    variant="text"
                    :tooltip="`${formatNumber(alert.total)} occurrence(s)`"
                    class="dashboard-compact-list__label"
                  >
                    {{ alert.word }}
                  </dashboard-tooltip-pill>
                  <strong>{{ formatNumber(alert.total) }}</strong>
                </li>
              </ol>
            </div>
          </template>
          <template #loading>
            <div class="dashboard-alerts-scroll">
              <div class="space-y-2">
                <div v-for="index in 2" :key="index" class="dashboard-skeleton h-8 rounded-lg"></div>
              </div>
            </div>
          </template>
          <template #empty>
            <div class="dashboard-compact-empty">Aucun mot sensible</div>
          </template>
        </dashboard-list-state>
      </section>

      <section class="dashboard-top-list dashboard-top-list--searches">
        <h4>Top 10 recherches</h4>
        <dashboard-list-state
          :loading="loadingPopularities"
          :has-data="topSearches.length"
          class="dashboard-keywords-list-state"
        >
          <template #default>
            <div class="dashboard-keywords-scroll flex-1 min-h-0 pr-1">
              <ol class="dashboard-compact-list">
                <li
                  v-for="(search, index) in topSearches"
                  :key="search.id || index"
                >
                  <span>#{{ index + 1 }}</span>
                  <dashboard-tooltip-pill
                    variant="text"
                    :tooltip="search.query"
                    class="dashboard-compact-list__label"
                  >
                    {{ search.query }}
                  </dashboard-tooltip-pill>
                  <dashboard-tooltip-pill
                    v-if="search.total !== undefined"
                    :tooltip="searchTooltip(search.total)"
                    class="dashboard-compact-list__count"
                  >
                    <strong>{{ formatNumber(search.total) }}</strong>
                  </dashboard-tooltip-pill>
                </li>
              </ol>
            </div>
          </template>
          <template #loading>
            <div class="flex-1 min-h-0 overflow-hidden">
              <div class="space-y-2">
                <div v-for="index in 5" :key="index" class="dashboard-skeleton h-8 rounded-lg"></div>
              </div>
            </div>
          </template>
          <template #empty>
            <div class="dashboard-compact-empty">Aucune recherche</div>
          </template>
        </dashboard-list-state>
      </section>
    </div>
  </dashboard-collapsible-card>
</template>

<script>
import DashboardCollapsibleCard from '@/components/dashboard/DashboardCollapsibleCard.vue'
import DashboardListState from '@/components/dashboard/DashboardListState.vue'
import DashboardMetricChip from '@/components/dashboard/DashboardMetricChip.vue'
import DashboardTooltipPill from '@/components/dashboard/DashboardTooltipPill.vue'

export default {
  name: 'DashboardTopKeywordsCard',
  components: {
    DashboardCollapsibleCard,
    DashboardListState,
    DashboardMetricChip,
    DashboardTooltipPill
  },
  props: {
    collapsed: {
      type: Boolean,
      required: true
    },
    loadingPopularities: {
      type: Boolean,
      default: false
    },
    topSearches: {
      type: Array,
      default: () => []
    },
    totalSearches: {
      type: Number,
      default: 0
    },
    keywordAlerts: {
      type: Array,
      default: () => []
    },
    selectedAlert: {
      type: Object,
      default: null
    },
    isExporting: {
      type: Boolean,
      default: false
    },
    formatNumber: {
      type: Function,
      required: true
    },
    periodLabel: {
      type: String,
      default: ''
    }
  },
  emits: ['toggle', 'export', 'toggle-alert'],
  methods: {
    searchTooltip (count) {
      const numericValue = Number(count)
      const formatted = this.formatNumber(count)
      if (Number.isFinite(numericValue)) {
        return `${formatted} recherche${Math.abs(numericValue) > 1 ? 's' : ''}`
      }
      return `${formatted} recherche(s)`
    }
  }
}
</script>
